
import {
  ColumnDef,
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table"

import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table"

type Payout = {
  payout_id: string
  date: string
  method: string
  status: string
  amount: string
}

const columns: ColumnDef<Payout>[] = [
  {
    accessorKey: "payout_id",
    header: "Payout ID",
    cell: ({ row }) => row.original.payout_id,
  },
  {
    accessorKey: "date",
    header: "Date",
    cell: ({ row }) => row.original.date,
  },
  {
    accessorKey: "method",
    header: "Method",
    cell: ({ row }) => row.original.method,
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => (
      <span className="bg-black text-white px-3 py-1 rounded-full text-sm font-medium">
        {row.original.status}
      </span>
    ),
  },
  {
    accessorKey: "amount",
    header: "Amount",
    cell: ({ row }) => row.original.amount,
  },
]

const payoutData: Payout[] = [
  {
    payout_id: "P-1234",
    date: "May 10, 2025",
    method: "Direct Deposit",
    status: "Paid",
    amount: "$2489.79",
  },
  {
    payout_id: "P-1235",
    date: "Apr 25, 2025",
    method: "Direct Deposit",
    status: "Paid",
    amount: "$1850.25",
  },
  {
    payout_id: "P-1236",
    date: "Apr 10, 2025",
    method: "Direct Deposit",
    status: "Paid",
    amount: "$2145.99",
  },
  {
    payout_id: "P-1237",
    date: "Mar 25, 2025",
    method: "Direct Deposit",
    status: "Paid",
    amount: "$1678.45",
  },
]

const PayoutHistoryTable = () => {
  const table = useReactTable({
    data: payoutData,
    columns,
    getCoreRowModel: getCoreRowModel(),
    filterFns: {
      categoryFilter: (row, columnId, filterValue) => {
        const value = row.getValue(columnId);
        return Boolean(
          value && String(value).toLowerCase().includes(String(filterValue).toLowerCase())
        );
      }
    },
  })

  return (
    <div className="mt-6">
      <div className="rounded-lg border bg-white">
        <div className="py-4 px-6 pb-2">
          <h2 className="text-2xl font-semibold text-gray-900 mb-1">Payout History</h2>
          <p className="text-gray-500 mb-4">Record of your past payouts</p>
        </div>
        <Table>
          <TableHeader>
            {table.getHeaderGroups().map(headerGroup => (
              <TableRow key={headerGroup.id}>
                {headerGroup.headers.map(header => (
                  <TableHead key={header.id} className="text-gray-500 font-medium pl-6">
                    {flexRender(header.column.columnDef.header, header.getContext())}
                  </TableHead>
                ))}
              </TableRow>
            ))}
          </TableHeader>
          <TableBody>
            {table.getRowModel().rows.length ? (
              table.getRowModel().rows.map(row => (
                <TableRow key={row.id} >
                  {row.getVisibleCells().map(cell => (
                    <TableCell key={cell.id} className="py-3 pl-6">
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={columns.length} className="h-24 text-center">
                  No results.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}

export default PayoutHistoryTable
